import React from "react";
import styles from "./styles.module.scss";

const RecaptchaNotice = () => {
    return (
        <div className={ styles.recaptchaNotice }>
            This site is protected by reCAPTCHA and the Google&nbsp;
            <a className={ styles.recaptchaNoticeLink } href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
            <a className={ styles.recaptchaNoticeLink } href="https://policies.google.com/terms">Terms of Service</a> apply.
        </div>
    );
};

export default RecaptchaNotice;
